import React from "react";
import { leaders, advisoryBoard } from "../../data/teamData";
import "./TeamStyle.css";
import { FaLinkedin } from "react-icons/fa";

function Team() {
  return (
    <div className="">
      {/* Leaders Section */}
      <section className=""> 

        <h2>Leaders</h2>
        <div className="team-grid">
          {leaders.map((member) => (
            <div key={member.id} className="team-card">
              <img src={member.image} alt={member.name} className="team-image" />
              <h3>{member.name}</h3>
              <p>{member.role}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Advisory Section */}
      <section className="team-section">
      <p> </p>
        <h2>Advisory Board</h2>
        <div className="team-grid">
          {advisoryBoard.map((member) => (
            <div key={member.id} className="team-card">
              <img src={member.image} alt={member.name} className="team-image" />
              <h3>{member.name}</h3>
              <p>{member.role}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Team;
